import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static get targets() {
    return ['input', 'parts', 'selected', 'box'];
  }

  initialize() {
    this.timeout = null;
    this.articleField = this.inputTarget;
  }

  connect() {
    const that = this;
    document.body.addEventListener('click', () => { that.partsTarget.style.display = 'none'; });

    this.inputTarget.addEventListener('keydown', () => this.searchShipmentParts());
    this.inputTarget.addEventListener('paste', () => setTimeout(this.searchShipmentParts(), 250));
  }

  disconnect() {
    this.inputTarget.removeEventListener('keydown', () => this.searchShipmentParts());
    this.inputTarget.removeEventListener('paste', () => this.searchShipmentParts());
  }

  renderNotFound(article) {
    this.partsTarget.innerHTML = `<div class="dropdown-item">Деталь «${article}» не найдена.</div>`;
    this.partsTarget.style.display = null;
  }

  renderPart(part) {
    var r = `
      <a class="dropdown-item" data-action="click->office--part--related-search#selectPart" data-part-id="${part.id}"
      data-article="${part.article}" data-description="${part.description}" data-brand-name="${part.brand_name}" data-name="${this.articleField.dataset.name}">
        ${part.brand_name} ${part.article} ${part.description}
      </a>
    `;
    if (part.crosses.length > 0) {
      for (const cross of part.crosses) {
        r = r + `
          <a class="part_${part.id} is-hidden" data-part-id="${cross.id}" data-description="${cross.description}"
          data-article="${cross.article}" data-brand-name="${cross.brand_name}" data-name="${this.articleField.dataset.name}">
            ${cross.brand_name} ${cross.article} ${cross.description}
          </a>
       `;
      }
    }
    return r
  }

  renderParts(parts) {
    const result = [];
    for (const part of parts) {
      result.push(this.renderPart(part));
    }
    this.partsTarget.innerHTML = result.join('');
    this.partsTarget.style.display = null;
  }

  searchShipmentParts() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const article = this.inputTarget.value.replace(/\s/g, '');
      if (article.length > 2) {
        const that = this;
        Rails.ajax({
          type: 'GET',
          url: `/office/parts/related_search?q=${article}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderParts(data);
            } else {
              that.renderNotFound(article);
            }
          },
          error: () => {
            alert('Ошибка при попытке найти детали по вашему запросу');
          },
        });
      }
    }, 500);
  }

  selectPart(event) {
    this.articleField.value = event.target.dataset.article;

    this.partsTarget.style.display = 'none';
    let box = this.selectedTarget;
    let qty = this.articleField.dataset.qty
    let default_qty = this.articleField.dataset.defaultqty

    if (this.articleField.dataset.multiple == 'true') {
      this.boxTarget.style.display = 'block';

      let part = document.createElement('p');

      if (qty == 'true') {
        part.innerHTML = `<div class="columns">
          <div class="column is-half">
            <label>
              <input type="checkbox" checked="checked" value="${event.target.dataset.partId}"
              name="${event.target.dataset.name}[]" id="${event.target.dataset.name}_${event.target.dataset.partId}">
              ${event.target.dataset.brandName} ${event.target.dataset.article} ${event.target.dataset.description}
            </label>
          </div>
          <div class="column is-narrow">
            <input style="width: 100px;" value="${default_qty ? default_qty : 1}" name="part_${event.target.dataset.partId}_qty" class="input has-text-centered">
          </div>
        </div>`;
      } else {
        part.innerHTML = `
          <label>
            <input type="checkbox" checked="checked" value="${event.target.dataset.partId}"
            name="${event.target.dataset.name}[]" id="${event.target.dataset.name}_${event.target.dataset.partId}">
            ${event.target.dataset.brandName} ${event.target.dataset.article} ${event.target.dataset.description}
          </label>`;
      };

      box.appendChild(part);

      if (document.querySelectorAll("part_" + event.target.dataset.partId)) {
        document.querySelectorAll(".part_" + event.target.dataset.partId).forEach(function (element) {
          let el = document.createElement('p');

          if (qty == 'true') {
            el.innerHTML = `<div class="columns">
              <div class="column is-half">
                <label>
                <input type="checkbox" value="${element.dataset.partId}"
                name="${element.dataset.name}[]" id="${element.dataset.name}_${element.dataset.partId}">
                ${element.dataset.brandName} ${element.dataset.article} ${element.dataset.description}
                </label>
              </div>
              <div class="column is-narrow">
                <input value="${default_qty ? default_qty : 1}" style="width: 100px;" name="part_${element.dataset.partId}_qty" class="input has-text-centered">
              </div>
            </div>`;
          } else {
            el.innerHTML = `
              <label>
              <input type="checkbox" value="${element.dataset.partId}"
              name="${element.dataset.name}[]" id="${element.dataset.name}_${element.dataset.partId}">
              ${element.dataset.brandName} ${element.dataset.article} ${element.dataset.description}
              </label>`;
          };

          box.appendChild(el);
        });
      }
    } else {
      if (this.partIdField.dataset.input) {
        document.getElementById(this.partIdField.dataset.input).value = event.target.dataset.partId;
      }
    }


  }
}
